import React from 'react';
import { COLOURING_CARD, COLOURING_SHEETS } from '../content/colouringComp';

interface ColouringCompCardProps {
  onOpen: () => void;
}

/**
 * Landing-page card for the junior colouring-in competition. Shown below the
 * pinned Groper card while isColouringCompOpen() is true (see LandingPage).
 * Compact, image-left layout so it doesn't compete with the pinned card.
 */
const ColouringCompCard: React.FC<ColouringCompCardProps> = ({ onOpen }) => {
  const sheet = COLOURING_SHEETS[0];
  return (
    <article
      aria-labelledby="colouring-card-heading"
      className="bg-white rounded-2xl shadow-lg overflow-hidden md:flex"
    >
      <div className="md:w-2/5 bg-white leading-[0] border-b md:border-b-0 md:border-r border-gray-100">
        <picture>
          <source type="image/webp" srcSet={`${sheet.webp640} 640w, ${sheet.webp1200} 1200w`} sizes="(min-width: 768px) 40vw, 100vw" />
          <img
            src={sheet.jpg}
            alt={sheet.alt}
            width={sheet.width}
            height={sheet.height}
            loading="lazy"
            decoding="async"
            className="block w-full h-auto"
          />
        </picture>
      </div>
      <div className="p-4 md:p-5 md:w-3/5 flex flex-col justify-center">
        <div className="flex flex-wrap items-center gap-2 mb-4">
          <span className="bg-orange-500 text-white text-xs font-extrabold tracking-wider uppercase px-3.5 py-1.5 rounded-full">
            {COLOURING_CARD.pill}
          </span>
          <span className="bg-gray-100 text-gray-600 text-xs font-bold tracking-wider uppercase px-3 py-1.5 rounded-full">
            {COLOURING_CARD.tag}
          </span>
        </div>
        <h3
          id="colouring-card-heading"
          className="text-2xl md:text-3xl font-extrabold text-[#1d2e61] leading-tight mb-3"
        >
          {COLOURING_CARD.headline}
        </h3>
        <p className="text-gray-700 md:text-lg leading-relaxed mb-5">{COLOURING_CARD.teaser}</p>
        <div>
          <button
            type="button"
            onClick={onOpen}
            className="bg-fishing-blue hover:bg-blue-700 text-white font-semibold px-5 py-2.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-fishing-blue"
          >
            {COLOURING_CARD.cta}
          </button>
        </div>
      </div>
    </article>
  );
};

export default ColouringCompCard;
